module.exports = __webpack_public_path__ + "static/img/cs-logo.6afa208.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cs-logo.png
// module id = VyxN
// module chunks = 1